import { CURRENT_SERVER } from '@/constants/domains'
import VueCookie from 'vue-cookie'
const axios = require('axios')

export default {
  getNotificationTimeoff ({
    limit = 9999,
    page = 1,
    user
  }) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    const query = [`page=${page}`, `limit=${limit}`, 'sort[]=requestDate', 'sort[]=-1']
    if (user) query.push(`user=${user}`)
    return instCred.get(`/userNotification?${query.join('&')}`)
  },
  checkHrNotification (body) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('hr/notifications/check', body)
  },
  deleteHrNotification (id) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.delete(`userNotification/${id}`)
  },
  deleteHrNotificationAll (userId) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.delete(`userNotification/all/${userId}`)
  },
  readHrNotificationAll (userId) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.put(`userNotification/all/${userId}`)
  },
  updateHrNotification (body, id) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.put(`userNotification/${id}`, body)
  }
}



// WEBPACK FOOTER //
// ./src/api/NotificationTimeoff/api.js